/** Flat node with expandable and level information */
export class InteractionFlatNode {
    label: string;
    type: any;
    data: any;
    level: number;
    expandable: boolean;
  }
